<template>
  <div>
    <section id="sub_visual" class="pic02">
      <p>이트너스샵 소개</p>
      <span>About etnersshop Service</span> </section>
    <main id="page_sub">
      <section id="page_contents" class="sub_con02 clear"> <span class="exr"><img src="../../assets/images/exr_01.png" width="452" height="209" alt=""/></span>
        <h6 class="w50p">최고의 제품을 최저가로.<br/>
          원하는 제품을 편하게 </h6>
        <span class="ctext1 w50p">가장 쉽고 저렴하게 국내 최고 브랜드 제품을 만날 수 있는 기회, 이트너스샵입니다. </span>
        <p class="ctext2"><span class="cbig">Why</span><span>etners shop?</span></p>
        <!--- 특징 --->
        <div class="clearfix">
          <ul class="platform">
            <li>
              <p><img src="../../assets/images/c_im_5.png" width="104" height="104" alt=""/></p>
              <h6>필요로 하는 모든 제품을 한번에 </h6>
              <p>최고 품질의 사무용 가전/가구를 합리적인 가격으로 한번에 구매 가능합니다. </p>
            <li>
              <p><img src="../../assets/images/c_im_6.png" width="104" height="104" alt=""/></p>
              <h6>기업 맞춤형 솔루션제공</h6>
              <p>기업 규모 및 기업 매출분석을 통해 사무환경에 맞는 최적의 견적을 제공합니다.</p>
            </li>
            <li>
              <p><img src="../../assets/images/c_im_7.png" width="104" height="104" alt=""/></p>
              <h6>원하는 제품을 편하게</h6>
              <p>찾는 물품이 없거나 의료장비, 특수설비 등 소싱하기 어려운 물품도 구매의뢰 및 상담이 가능합니다. </p>
            </li>
            <li>
              <p><img src="../../assets/images/c_im_8.png" width="104" height="104" alt=""/></p>
              <h6>언제 어디서든 편리한 문의 및 실시간 응대</h6>
              <p>1대1 상담을 통한 맞춤 컨설팅 및 빠른 문의/답변이 가능하여 번거로은 소싱과 구매를 한번에 해결합니다. </p>
            </li>
          </ul>
        </div>
        <!--- //특징 --->
        <go-solution :solutionUrl="url" :solCd="solCd" :solGrup="10" :solNm="solNm"></go-solution>
      </section>
    </main>
  </div>
</template>

<script>
  import GoSolution from "../../components/goSolution";
  export default {
    components: {GoSolution},
    data() {
      return{
          url:'http://www.etnersshop.com',
          solNm :'이트너스샵',
          solCd : '2000'
      }
    }

  }

</script>
